const SVG = ({ width = '23', height = '22', viewBox = '0 0 23 22', filled }) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 0.5L15.6233 6.32475L22.4371 8.4463L18.1717 14.1678L18.2595 21.3037L11.5 19.015L4.74047 21.3037L4.82834 14.1678L0.56285 8.4463L7.37669 6.32475L11.5 0.5Z"
      fill={filled ? '#B69B64' : '#acacac'}
    />
  </svg>
);

export default SVG;
